import React from 'react'
import * as Fields from 'support/fields'
import {
  ExecuteOperationOnPipe,
  ModelWithForm,
  TriggerPipelineOnFormSubmit,
  WhenModelValue,
} from '@morningtrain/react-resources'
import Button from 'ui/buttons/Button'
import TranslatedTitle from 'widgets/TranslatedTitle'
import { Translation } from '@morningtrain/react-translations'
import * as UI from 'ui'
import Fieldset from 'layouts/form/Fieldset'
import RedirectToEditOnCreatePipeline from 'support/pipelines/RedirectToEditOnCreatePipeline'
import DeleteModelOnClick from 'support/actions/generic/DeleteModelOnClick'
import { NavigateOnPipe, WhenRouteHasParameter } from '@morningtrain/react-navigation'
import { Can } from '@morningtrain/react-auth'
import Permissions from 'services/Permissions'
import Tablets from 'pages/app/settings/Tablets'
import PerformanceIndicatorEditor from 'pages/app/settings/departments/partials/PerformanceIndicatorEditor'
import { Pipeline } from '@morningtrain/react-pipelines'
import DepartmentUsers from "pages/app/inventory/supplier/partials/DepartmentUsers";

export default function DepartmentEditForm () {
  const resourceName = 'departments'

  return (
    <ModelWithForm resourceName={resourceName}>
      <UI.PageHeader title={(
        <>
          <WhenRouteHasParameter name='department'>
            <TranslatedTitle name='titles.edit' />
          </WhenRouteHasParameter>
          <WhenRouteHasParameter name='department' negate>
            <TranslatedTitle name='titles.create' />
          </WhenRouteHasParameter>
        </>
      )}
      >
        <div className='flex space-x-4'>
          <DeleteModelOnClick pipes={<NavigateOnPipe route='app.settings.departments.index' />}>
            <UI.DeleteButton big />
          </DeleteModelOnClick>
          <Button text={<Translation name='generic.save' />} type='submit' />
        </div>
      </UI.PageHeader>
      <UI.CardGroup>
        <UI.Card>
          <Fieldset cols={2}>
            <Fields.Input name='name' label={<Translation name='fields.name.label'/>}/>
            <Fields.Input name='company_name' label={<Translation name='fields.company_name.label'/>}/>
            <Fields.Input name='address' label={<Translation name='fields.address.label'/>}/>
            <Fields.Input name='zipcode' label={<Translation name='fields.zipcode.label'/>}/>
            <Fields.Input name='cvr' label={<Translation name='fields.cvr.label'/>}/>
            <Fields.Input name='phone' type='tel' label={<Translation name='fields.phone.label'/>}/>
            <Fields.Input name='employer_salary_id' label={<Translation name='fields.employer_salary_id.label'/>}/>
            <Fields.Checkbox name='skip_contract_creation'
                             label={<Translation name='fields.skip_contract_creation.label'/>}/>
            <Fields.Date name='in_production_at'/>
            <Fields.EmployeeField/>
            <Fields.Input name='email'
                          label={<Translation name='fields.email.label'/>}/>
            <Fields.Input name='employee_inactivated_email'
                          label={<Translation name='fields.employee_inactivated_email.label'/>}/>
          </Fieldset>
        </UI.Card>
        <UI.Card>
          <Fields.Input
              name='notify_minutes_before_late_order'
              label={<Translation name='fields.notify_minutes_before_late_order.label' />}
              type='number'
          />
          <DepartmentUsers/>
        </UI.Card>
        <UI.CardWithHeader header={<Translation name='headers.apikeys' />}>
          <Fieldset cols={1}>
            <Fields.Input name='yr_no_url' label={<Translation name='fields.yr_no_url.label' />} />
            <Fields.Input name='economic_token' label={<Translation name='fields.economic_token.label' />} />
            <Fields.Input name='provargo_api_key' label={<Translation name='fields.provargo_api_key.label' />} />
          </Fieldset>
        </UI.CardWithHeader>
        <UI.CardWithHeader header={<Translation name='headers.wage_ratio_kpis' />}>
          <WhenModelValue name='id'>
            <div className='space-y-4'>
              <PerformanceIndicatorEditor year={(new Date()).getFullYear() - 1} />
              <PerformanceIndicatorEditor year={(new Date()).getFullYear()} />
              <PerformanceIndicatorEditor year={(new Date()).getFullYear() + 1} />
            </div>
          </WhenModelValue>
        </UI.CardWithHeader>
        <UI.CardWithHeader header={<Translation name='fields.pos_location_id.label' />}>
          <Fields.ResourceSelector
            resourceName='pos.locations'
            name='pos_location_id'
            optionsKey='GLOBAL_ID'
            modifyCollection={(c) => (c.map(val => ({
              // todo: replace this when ResourceSelector supports specifying primaryKey
              value: typeof val.get === 'function' ? val.get('ID') : val.ID,
              label: typeof val.get === 'function' ? val.get('GLOBAL_ID') : val.GLOBAL_ID
            })))}
          />
        </UI.CardWithHeader>

        <WhenModelValue name='id'>
          <Can permission={Permissions.SETTINGS_MANAGE_TABLETS}>
            <div className='pt-10'>
              <Tablets />
            </div>
          </Can>
        </WhenModelValue>

      </UI.CardGroup>

      <Pipeline>
        <TriggerPipelineOnFormSubmit />
        <ExecuteOperationOnPipe resourceName='performance_indicators' operationName='by_month' operationContext={{ year: (new Date()).getFullYear() - 1 }} />
        <ExecuteOperationOnPipe resourceName='performance_indicators' operationName='by_month' operationContext={{ year: (new Date()).getFullYear() }} />
        <ExecuteOperationOnPipe resourceName='performance_indicators' operationName='by_month' operationContext={{ year: (new Date()).getFullYear() + 1 }} />
      </Pipeline>

      <RedirectToEditOnCreatePipeline routeName='app.settings.departments.edit' />
    </ModelWithForm>
  )
}
